module.exports = __webpack_public_path__ + "img/BASHK.a11fa550.png";